import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from './api.service';
import { ApiResponse, CartItem } from '../interfaces';
import { Product, ServiceTypes } from '../models';

@Injectable({
  providedIn: 'root'
})
export class AdditionalService {
  constructor(private apiService: ApiService) {}
  getServiceByProduct(cartItem: CartItem): Observable<ServiceTypes>  {
    const body = {
      skuCode: cartItem.skuCode,
      entityCode: cartItem.data.entityCode,
      additionalType: ''
    };
    return this.apiService.post(this.apiService.getServices, body).pipe(
      map((serviceTypes: ServiceTypes) => {
        serviceTypes.types.map(service => {
          service.services = [];
          return service;
        });
        serviceTypes.services = Object.keys(serviceTypes.services).length ? serviceTypes.services : null;
        return serviceTypes;
      })
    );
  }
}
